var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHotspot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.012,
    height: 36.012,
    viewBox: "0 0 36.012 36.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-739.448 -216.993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.006,0A18.006,18.006,0,1,1,0,18.006,18.006,18.006,0,0,1,18.006,0Z",
    transform: "translate(739.448 216.993)",
    fill: "#a78724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.006,2A16.006,16.006,0,0,0,6.688,29.324,16.006,16.006,0,1,0,29.324,6.688,15.9,15.9,0,0,0,18.006,2m0-2A18.006,18.006,0,1,1,0,18.006,18.006,18.006,0,0,1,18.006,0Z",
    transform: "translate(739.448 216.993)",
    fill: "#fffefa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.486,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H13.486a1,1,0,0,1,1,1A1,1,0,0,1,13.486,1Z",
    transform: "translate(750.71 235)",
    fill: "#fffefa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.486,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H13.486a1,1,0,0,1,1,1A1,1,0,0,1,13.486,1Z",
    transform: "translate(757.453 228.257) rotate(90)",
    fill: "#fffefa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHotspot);
export default __webpack_public_path__ + "static/media/icon-hotspot.bbacb9f9.svg";
export { ForwardRef as ReactComponent };